const lib = {
  statusCode: {
    ok: 200,
    badRequest: 400
  },

  isNullOrEmptyObject: (obj) => {
    if (obj === null || obj === undefined) return true;

    if (obj === '') return false;

    if (Array.isArray(obj)) return false;

    for (let p in obj) return false;

    return true;
  },

  formatToCurrencyText: (value) => {
    if (typeof value === 'number') {
      let valor = value.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      });

      return valor;
    }
    return undefined;
  },

  capitalizeFirstLetter: (string) => {
    if(string != "" && string != null){
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
  },

  formatToNumeric: (value, decimalCases = 2, noCases = false) => {
    if (typeof value === 'number' && value !== 0) {
      let valorFormatado = value.toFixed(decimalCases).toString().replace('.', ',');
      const valorInteiro = valorFormatado.split(',')[0];
      const valorDecimal = valorFormatado.split(',')[1] ?? '000';

      let valorComMilhar = "";
      let indexInicio = valorInteiro.length;

      if(valorInteiro.length > 3){
        for(let i = valorInteiro.length - 3; i > 0; i -= 3) {
          valorComMilhar = '.' + valorInteiro.slice(i, i + 3) + valorComMilhar;
          indexInicio = i;
        }
      }

      //valorComMilhar = valorInteiro.slice(0, indexInicio) + valorComMilhar;
      valorComMilhar = valorInteiro.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      if(noCases) {
        return valorComMilhar;
      }

      valorComMilhar += "," + valorDecimal;

      return valorComMilhar;
    } 
    return value;
  },

  formatCep: (str) => {
    var re = /^([\d]{5})-?([\d]{3})/;

    if (re.test(str)) return str.replace(re, '$1-$2');

    return str;
  },

  parseCopiedText: (event) => {
    const selectedText = window.getSelection().toString();
    
    const withoutDots = selectedText.replace(/\.(?!(?:\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}))/g, '')
                                    .replaceAll('R$ ', '')
                                    .replaceAll(' Kg', '')
                                    .replaceAll("%", "")
                                    .replaceAll("REALIZADO", "REALIZADO\t");

    const finalResult = withoutDots.replaceAll(/(\n)([0-9]{2,}\/[0-9]{2,}-[0-9]{2,})(\n)/g, ' - $2\t');

    event.clipboardData.setData('text/plain', finalResult);
    event.preventDefault();
  },

  getStringFromDate: (data) => {
    if (!data) return '';

    let parsedData = new Date(data);

    var dia = parsedData.getDate().toString(),
      diaF = dia.length == 1 ? '0' + dia : dia,
      mes = (parsedData.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? '0' + mes : mes,
      anoF = parsedData.getFullYear();
    return diaF + '/' + mesF + '/' + anoF;
  },

  getStringFromDateTime: (data) => {
    if (!data) return '';

    let parsedData = new Date(data);

    return parsedData.toLocaleDateString('pt-BR', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
  },

  getStringFromDateMinute: (data) => {
    if (!data) return '';

    let parsedData = new Date(data);

    return parsedData.toLocaleDateString('pt-BR', {
      hour: 'numeric',
      minute: 'numeric'
    });
  },

  getDate: (data) => {
    if (!data) return '';

    let parsedData = new Date(data);

    return parsedData;
  },

  getDateFromString: (str) => {
    if (!str || !str.length) return null;

    var parts = str.split('/');
    if (parts.length < 3) return null;

    return new Date(parts[2], parts[1] - 1, parts[0]);
  },

  getDateFromStringJson: (obj) => {
    try {
      if (!obj) return null;

      let str = obj.toString();
      if (!str.length) return null;

      var parsedData = new Date(str);
      if (parsedData === 'Invalid Date') return null;

      if (isNaN(new Date(parsedData))) return null;

      return parsedData;
    } catch (error) {
      return null;
    }
  },

  _base64ToByteArray: (base64) => {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }

    return bytes;
  },

  downloadFile: (data, fileName) => {
    function base64ToByteArray(base64) {
      let binary_string = window.atob(base64);
      let len = binary_string.length;
      let bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }

      return bytes;
    }

    let file = base64ToByteArray(data);
    let blob = new Blob([file], { type: 'arraybuffer' });

    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    let fileURL = window.URL.createObjectURL(blob);
    a.href = fileURL;
    a.download = fileName;
    a.click();
  },

  getCurrentDateFilename: () => {
    let today = new Date();
    return `${today.getFullYear()}_${today.getMonth() + 1}_${today.getDate()}`;
  },

  selectListSituacao: [
    { value: '', label: 'Todos' },
    { value: 'A', label: 'Ativos' },
    { value: 'I', label: 'Inativos' }
  ],

  getPrimeiroDiaMesAnterior: () => {
    const inicio = new Date();
    inicio.setHours(0, 0, 0, 0);
    inicio.setMonth(inicio.getMonth() - 1);
    inicio.setDate(1);

    return inicio;
  },

  getUltimoDiaMesAnterior: () => {
    const fim = new Date();
    fim.setHours(0, 0, 0, 0);
    fim.setDate(0);

    return fim;
  },

  selectListMeses: [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' }
  ],

  selectListAnos: Array(new Date().getFullYear() + 2 - 2022)
    .fill()
    .map((_, idx) => 2022 + idx)
    .map((ano) => ({
      value: ano,
      label: ano
    })),

  pedidoTipos: {
    venda: { sigla: 'V' },
    bonificacao: { sigla: 'B' },
    amostra: { sigla: 'A' },
    degustacao: { sigla: 'D' }
  }
};

export default lib;
